import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TransactionOutlinedSvg from "@ant-design/icons-svg/es/asn/TransactionOutlined";
import AntdIcon from "../components/AntdIcon";
var TransactionOutlined = function TransactionOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TransactionOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TransactionOutlined.displayName = 'TransactionOutlined';
}
export default /*#__PURE__*/React.forwardRef(TransactionOutlined);